import { DynamicEpisodesModel } from '@models/DynamicEpisodesModel.js';
import { useEffect, useState } from 'react';

const useLatestEpisodesQuery = (dataSource) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (dataSource?.source && dataSource?.source === 'manual') {
            setIsLoading(false);
        }
        if (dataSource && dataSource.apiUrl && dataSource?.source === 'dynamic') {
            const fetchData = async () => {
                try {
                    const urlWithParams = new URL(dataSource.apiUrl);
                    const params = {pageId:dataSource?.pageId, episodeSlug: dataSource?.episodeSlug, postsCount: dataSource?.postsCount};
                    Object.keys(params).forEach((key) => urlWithParams.searchParams.append(key, params[key]));

                    const response = await fetch(urlWithParams);

                    if (response.ok) {
                        const jsonData = await response.json();
                        setData(jsonData);
                    } else {
                        throw new Error('Error fetching data');
                    }
                } catch (error) {
                    setError(error);
                } finally {
                    setIsLoading(false);
                }
            };

            void fetchData();
        }
    }, [dataSource?.apiUrl, dataSource?.source]);

    return {
        model: new DynamicEpisodesModel(data),
        error,
        isLoading,
    };
};

export default useLatestEpisodesQuery;
